//
import { mapActions, mapState } from 'vuex'
import {
    ModelDataTable,
    VBtnAction,
} from '@/components/reusable_components/next'

//
import DispatchRequestBatchToListModel from '@/models/Warehouse/WhDispatchRequestBatchToList'
import DispatchRequestBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'
import TranslatorService from '@/services/translator'

//
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'dispatch-requests-batch-list',
    components: {
        ModelDataTable,
        VBtnAction,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                attachParams: {
                    item_number: '1',
                    can_be_dispatched: '1',
                },
                service: DispatchRequestBatchToListModel,
                filters,
                headers,
            }
        },

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', ['setTitleTopBar', 'setItemsTopBar']),

        //
        ...mapActions('SnackbarModalModule', [
            'resetSnackbarState',
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         *
         */
        details() {
            this.submitUpdate({ item: this.selected })
        },

        /**
         *
         */
        dispatch() {
            console.log()
            return this.selected
                .dispatched()
                .sync()
                .then(this.successDispatch)
                .catch(this.error)
                .then(this.refresh)
        },

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(
                    DispatchRequestBatchModel,
                    error.response.data
                )
            )
        },

        /**
         *
         */
        refresh() {
            this.$refs.table.refresh()
        },

        /**
         *
         */
        remove() {
            return this.selected
                .delete()
                .then(this.successRemove)
                .catch(this.error)
                .then(this.refresh)
        },

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'dispatch-request-batch-create' })
        },

        /**
         *
         */
        submitDispatch(event) {
            DispatchRequestBatchModel
                .modeler()
                .find(event.item.id)
                .then(this.toDispatch)
        },

        submitPdf(event) {
            DispatchRequestBatchModel
                .modeler()
                .find(event.item.id)
                .then(this.toPdf)
        },

        /**
         *
         */
        submitReception(event) {
            this.$router.push({
                name: 'dispatch-request-batch-reception',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        submitRemove(event) {
            //
            this.setWarningSnackbar({
                title: '¿Deseas eliminar el lote de despacho?',
                message: 'Una vez eliminado no se puede recuperar.',
                confirm: 'eliminar',
            })

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'dispatch-request-batch-update',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        successDispatch() {
            this.setSuccessSnackbar('Lote de despacho despachado exitosamente.')
        },

        /**
         *
         */
        successRemove() {
            this.setSuccessSnackbar('Lote de despacho eliminado exitosamente.')
        },

        toDispatch(model) {

            //
            if (!model.can_dispatch) {
                //
                return this.setWarningSnackbar({
                    title: 'Error',
                    color: 'error',
                    message: 'Faltan solicitudes de despacho por facturar.',
                    confirm: 'ver detalle',
                })
            }
            //
            this.setWarningSnackbar({
                title: '¿Deseas despachar el lote de despacho?',
                message: 'Una vez despachado no se puede editar.',
                confirm: 'despachar',
            })

            //
            this.selected = model
        },

        toPdf(model) {
            return model.print_as_pdf()
        },
    },
    beforeMount() {
        //
        this.setTitleTopBar('Lotes de despacho')

        //
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                color: 'accent',
                icon: 'add_circle',
                text: 'crear lote de despacho',
                tip: 'Crear nuevo lote de despacho',
                can: 'CREATE_DISPATCH_REQUEST_BATCH',
            },
        ])
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'despachar':
                    this.resetSnackbarState().then(this.dispatch)
                    break
                case 'eliminar':
                    this.resetSnackbarState().then(this.remove)
                    break
                case 'ver detalle':
                    this.resetSnackbarState().then(this.details)
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_DISPATCH_REQUEST_BATCH'))
                ctx.$router.push('/')
        })
    },
}
